export default "__VITE_ASSET__$$YcuOwL__"